import { StateCreator } from "zustand";
import { AUTH_HEADER, SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY} from "../../../base";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import Endpoints from "../../../domain/endpoints";
import { FetchCustomerwiseInputReport } from "../../../domain/useages/input-utilization/fetch-customerwise-input-report";
import { RemoteFetchCustomerWiseInputReport } from "../../../data/usecases/input-utilization/remote-fetch-customerwise-input-report";
import { FetchState } from "../../../domain/models/fetch-state";
import dayjs from "dayjs";
import moment from "moment";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";

interface FetchCustomerWiseInputReportInterface {
  fetchCustomerWiseInputReport: Function;
  customerWiseInputReportData: any[];
  fetchCustomerWiseDataState: FetchState;
  customerWiseDataFilters: {
    input_ids?: string[];
    role_id?: string;
    product_type?: string;
    month_years: string[];
    length: number;
    page: number;
  };
  total_data: number;
}

const initialStates = {
  customerWiseInputReportData: [],
  fetchCustomerWiseDataState: FetchState.DEFAULT,
  customerWiseDataFilters: {
    page: 1,
    length: 100,
    month_years: [moment(dayjs(new Date())?.toString()).format("YYYYMM")],
  },
  total_data: 0,
};

const axiosHttpClient = AxiosHttpClient.getInstance();


export const useFetchCustomerWiseInputReportSlice: StateCreator<
  FetchCustomerWiseInputReportInterface
> = (set, get) => ({
  ...initialStates,
  fetchCustomerWiseInputReport: async () => {
    set(() => ({ fetchCustomerWiseDataState: FetchState.LOADING }));
    const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
    const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);
    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });
    const remoteFetchCustomerWiseInputReport: FetchCustomerwiseInputReport =
      new RemoteFetchCustomerWiseInputReport(
        `${BASE_URL}${Endpoints.FETCH_CUSTOMER_WISE_INPUT_REPORT}`,
        axiosHttpClient
      );

    let payload = {
      role_id: get().customerWiseDataFilters.role_id,
      length: get().customerWiseDataFilters.length,
      page: get().customerWiseDataFilters.page,
      input_ids: get().customerWiseDataFilters.input_ids,
      month_years: get().customerWiseDataFilters.month_years,
      product_type: get().customerWiseDataFilters.product_type,
    };

    let result = await remoteFetchCustomerWiseInputReport.fetch(payload);
    if (result.customer_summary.length > 0) {
      set(() => ({
        customerWiseInputReportData: result.customer_summary,
        fetchCustomerWiseDataState: FetchState.SUCCESS,
        total_data: result.total,
      }));
    } else {
      set(() => ({
        customerWiseInputReportData: result.customer_summary,
        fetchCustomerWiseDataState: FetchState.ERROR,
        total_data: result.total,
      }));
    }
  },
});
